module.exports = __webpack_public_path__ + "img/675x365.b9c4eb26.png";